import React, { useState } from 'react';

import { useCountLines } from '../../utils/hooks/useCountLines';

import type { CoachBioCoachFragment } from './__generated-gql-types__/CoachBio.generated';

interface CoachBioProps {
  className?: string;
  coach: CoachBioCoachFragment;
}

const CoachBio: React.FC<CoachBioProps> = ({ className, coach }) => {
  const [bioLines, bioRef] = useCountLines();

  const [expandedBio, setExpandedBio] = useState(false);

  return (
    <div className={className}>
      <h2 className="mb-4 text-left text-2xl font-medium text-leland-gray-dark">
        About {coach.user.firstName}
      </h2>
      <p
        ref={bioRef}
        className={`whitespace-pre-line break-words text-lg font-normal text-leland-gray-light ${
          !expandedBio && bioLines >= 4 && 'line-clamp-4'
        }`}
      >
        {coach.bio}
      </p>
      {bioLines > 4 ? (
        <button
          className="link link--primary mt-0.5 text-base font-medium"
          onClick={() => setExpandedBio((prevState) => !prevState)}
          id="coach_bio--toggle_bio"
        >
          {expandedBio ? 'Read less' : 'Read more'}
        </button>
      ) : null}
    </div>
  );
};

export default CoachBio;
